<section class="page-container">
    <div class="flex min-w-0 items-center justify-between gap-4">
      <h1 class="main-heading min-w-0">Manage Loan Status</h1>
      <app-navpath class="hidden md:block"></app-navpath>
    </div>
    <div class="mb-2 mt-4 flex w-full flex-col gap-1 md:w-fit md:flex-row">
        <button class="shorter-btn misc-btn" [disabled]="!canUpdate()" (click)="updateEntry()">
            <fa-icon [icon]="faSave" class="mr-1"></fa-icon>Update
        </button>
    </div>
    <div class="content-container">
      <app-data-form
        [dataFields]="mainFormFields"
        (clickSearch)="fetchLoanStatus($event)"
        (updateFields_child)="onFieldChange($event)"
      ></app-data-form>
      <div class="w-full lg:w-1/2">
        <app-data-form
          [dataFields]="lowerFormFields"
          [columns]="1"
          (updateFields_child)="onFieldChange($event)"
        ></app-data-form>
      </div>
    </div>
</section>
  
